var $ba19b07a1b9e5177$exports = {};
$ba19b07a1b9e5177$exports = {
    "collapse": `Sak\u{13C}aut`,
    "expand": `Izv\u{113}rst`
};


export {$ba19b07a1b9e5177$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
